export default __webpack_public_path__ + "static/media/new_5.ae7b0e99.jpeg";